module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 "
  }, [_c('h1', [_vm._v("Trending Surveys")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_vm._v(_vm._s(survey.cnsurvey_title))])])]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }]
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          staticClass: "options"
        }, [(_vm.check_if_user_has_polled(svq.cnsurveys_answers) || svq.polled) ? _c('div', [_c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))]), _vm._v(" "), _c('p', {
          staticClass: "pull-right",
          staticStyle: {
            "margin-top": "-0.7em"
          }
        }, [_vm._v("  " + _vm._s(_vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers)))]), _vm._v(" "), _c('div', {
          staticClass: "progress",
          staticStyle: {
            "height": "0.2em"
          }
        }, [_c('div', {
          staticClass: "progress-bar progress-bar-info",
          style: ({
            width: _vm.get_option_answer(opt.cnsurvey_option_id, svq.cnsurveys_answers) + '%'
          }),
          attrs: {
            "role": "progressbar",
            "aria-valuenow": "60",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]) : _c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.answer),
            expression: "answer"
          }],
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id,
            "checked": _vm._q(_vm.answer, opt.cnsurvey_option_id)
          },
          on: {
            "__c": function($event) {
              _vm.answer = opt.cnsurvey_option_id
            }
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('ul', _vm._l((_vm.surveys.count_range), function(count) {
    return _c('li', {
      class: {
        active: _vm.isActive(count)
      },
      model: {
        value: (_vm.current_page),
        callback: function($$v) {
          _vm.current_page = $$v
        },
        expression: "current_page"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSurveys(((count - 1) * _vm.pag_intv), count)
        }
      }
    }, [_vm._v(_vm._s(count))])])
  }))])])])], 1)])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('create-thread'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "guest-poll",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-offset-2 modal-content",
    staticStyle: {
      "top": "10em",
      "border-radius": "0px",
      "padding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Thank you for making your opinion count! If you would like to partake in future CNsurveys, \r\n                or create your own CNsurvey, and stand the chance of earning random rewards , register now!\r\n                ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/register",
      "type": "button"
    }
  }, [_vm._v("Sign Up")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-image": "url('https://cityneeds.ng/cnpro.jpg')",
      "height": "8em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc1118c"}!./src/components/Cnsurveys/template.html
// module id = 290
// module chunks = 0